import React from "react";
import Image from "@components/Image";
import cx from "classnames";
import styles from "./ImagesGroup.module.scss";
import _ from "lodash";

// Local fallbacks used only when Strapi returns no images, so the 3-slot
// layout never renders empty. When the CMS has images we render those instead
// (previously the hardcoded images always rendered and masked CMS updates).
const FALLBACK_IMAGES = [
  { src: "/about/careers/1.jpg", alt: "image-about-careers-1" },
  { src: "/about/careers/2.jpg", alt: "image-about-careers-2" },
  { src: "/about/careers/3.jpg", alt: "image-about-careers-3" },
];

export default function ImagesGroup({ images }: any) {
  const displayImages = _.isEmpty(images) ? FALLBACK_IMAGES : images;

  return (
    <div className={cx(styles.section)}>
      {_.map(displayImages, (image, index: number) => {
        const indexImage = (index + 1) % 3 === 0 ? 3 : (index + 1) % 3;
        return (
          <div key={index} className={cx(styles[`imageBox${indexImage}`])}>
            <Image
              wrapperProps={{ className: cx(styles[`image${indexImage}`]) }}
              {...image}
              alt={image?.alt || `Careers image ${index + 1}`}
              layout="fill"
            />
          </div>
        );
      })}
    </div>
  );
}
